var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.82,
    height: 21.82,
    viewBox: "0 0 21.82 21.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cancel_FILL0_wght400_GRAD0_opsz48",
    d: "M86.819,192.147l4.091-4.091L95,192.147,96.147,191l-4.091-4.091,4.091-4.091L95,181.673l-4.091,4.091-4.091-4.091-1.146,1.146,4.091,4.091L85.673,191Zm4.091,5.673a10.556,10.556,0,0,1-4.228-.859,10.992,10.992,0,0,1-5.823-5.823,10.9,10.9,0,0,1,0-8.483,10.9,10.9,0,0,1,2.346-3.464,11.184,11.184,0,0,1,3.478-2.332,10.9,10.9,0,0,1,8.483,0,10.893,10.893,0,0,1,5.8,5.8,10.9,10.9,0,0,1,0,8.483,11.184,11.184,0,0,1-2.332,3.478,10.9,10.9,0,0,1-3.464,2.346A10.624,10.624,0,0,1,90.91,197.82Zm0-1.637a9.266,9.266,0,1,0-6.56-2.714A8.924,8.924,0,0,0,90.91,196.184ZM90.91,186.91Z",
    transform: "translate(-80 -176)",
    fill: "#231f20",
    opacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross_circle.acb2ea7b55f2406822e2326fe0bc32d5.svg";
export { ForwardRef as ReactComponent };